import React from 'react'
import { useController } from 'react-hook-form'
import type { Control, FieldPath, FieldValues } from 'react-hook-form'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Props<T extends React.ComponentType<any>, TFieldValues extends FieldValues> = {
	control: Control<TFieldValues>
	name: FieldPath<TFieldValues>
	component: T
} & Omit<React.ComponentPropsWithRef<T>, 'input' | 'meta'>

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const HookFormField = <T extends React.ComponentType<any>, TFieldValues extends FieldValues>(props: Props<T, TFieldValues>) => {
	const { control, name, component, ...rest } = props
	const FieldComponent = component as React.ComponentProps<T>

	const { field, fieldState } = useController<TFieldValues>({
		name,
		control
	})

	return <FieldComponent {...rest} name={name} input={field} meta={{ ...fieldState, error: fieldState?.error?.message ? fieldState.error.message : null }} />
}

export default HookFormField
